<template>
  <div class="reader-widget">
    <div class="actions">
      <ReaderStateButtons
        @add="onAdd"
        @selected="onToggleMinimize"
        :selected-readers="minimizedReaders"
      />
    </div>
    <div class="readers">
      <template v-for="(reader, index) in readers">
        <Reader @clone="onClone" :readerId="reader.readerId" :key="reader.readerId" :selection="reader.selection" :index="index" v-show="minimizedReaders.indexOf(reader.readerId) === -1" />
      </template>
    </div>
  </div>
</template>

<script>

  import ReaderStateButtons from '../components/ReaderStateButtons/ReaderStateButtons.vue';
  import Reader from '../components/Reader.vue';
  import mixins from '../mixins';
  import utils from '../utils';
  import { OPEN_BIRDS_EYE, CLOSE_BIRDS_EYE, RESET_READERS } from '../constants';

  export default {
    scaifeConfig: {
      displayName: '',
    },
    created() {
      this.determineInitialBirdseyeState();
      this.initializeReaders();
    },
    data() {
      return {
        minimizedReaders: [],
      };
    },
    watch: {
      selectedIds: {
        // this handler is used to synchronize reader selections
        // made outside of `RouteReaderSelectionsMixin`
        // (e.g., named entities)
        handler() {
          this.readers.forEach((reader, index) => {
            const newId = this.selectedIds[index];
            if (newId !== reader.selection.id) {
              const newSelection = utils.parseId(newId);
              this.updateReader(reader.readerId, newSelection);
            }
          });
        },
      },
    },
    computed: {
      readers() {
        return this.$store.state.readers;
      },
    },
    mixins: [mixins.RouteReaderSelectionsMixin],
    components: { Reader, ReaderStateButtons },
    methods: {
      onToggleMinimize(readerId) {
        const index = this.minimizedReaders.indexOf(readerId);
        if (index === -1) {
          this.minimizedReaders = [...this.minimizedReaders, readerId];
        } else {
          this.minimizedReaders.splice(index, 1);
        }
      },
      onClone(readerId) {
        this.cloneReader(readerId);
      },
      onAdd() {
        this.addReader();
      },
      determineInitialBirdseyeState() {
        if (this.selections.length === 1) {
          this.$store.dispatch(OPEN_BIRDS_EYE);
        } else {
          this.$store.dispatch(CLOSE_BIRDS_EYE);
        }
      },
    },
    destroyed() {
      this.$store.dispatch(RESET_READERS);
    },
  };
</script>

<style lang="scss">
  @import "../variables.scss";
  #app[data-locale="ar"] {
    .readers, .reader-widget .actions a {
      flex-direction: row-reverse;
    }
  }
  .widget h2.main-widget-heading {
    display: none;
  }
  .reader-widget .actions {
    text-align: right;
    margin: 5px 20px;
    height: 30px;
    a {
      display: flex;
      justify-content: flex-end;
      padding: 4px 8px;
      span {
        margin: -3px 5px 0;
      }
      color: $gray-600;
    }
  }
  .reader-widget .readers {
    margin: 0 3em;
    display: flex;
    flex-direction: row;
    justify-content: center;
    height: calc(100vh - 95px);
  }

  .reader-widget .populated.state-button {
    cursor: pointer;
  }
</style>
